import { Link } from 'react-router-dom';
import type { JobView } from '@/hooks/useActiveJobs';
import { formatJobDate, relativeDayLabel } from '@/lib/format';
import { ClockIcon, PinIcon } from '../icons';
import { WorkerCountTag } from '../ui/WorkerCountTag';

export function RegistrationPill({ state }: { state: JobView['registration'] }) {
  return state === 'open' ? (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-ok-soft px-2 py-0.5 text-[12px] font-semibold text-ok">
      <span className="size-1.5 rounded-full bg-ok" aria-hidden="true" />
      הרשמה פתוחה
    </span>
  ) : (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-sunken px-2 py-0.5 text-[12px] font-semibold text-ink-2">
      <span className="size-1.5 rounded-full bg-ink-3" aria-hidden="true" />
      הרשמה סגורה
    </span>
  );
}

export function JobRow({ job }: { job: JobView }) {
  const rel = relativeDayLabel(job.date);
  return (
    <li>
      <Link
        to={`/jobs/${job.id}`}
        className="flex items-center gap-4 rounded-card border border-line bg-surface p-4 transition-colors hover:border-line-strong active:bg-sunken"
      >
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <h3 className="truncate text-[16px] font-semibold">{job.name}</h3>
            {job.pendingRequestCount > 0 && (
              <span className="rounded-full bg-danger-soft px-2 py-0.5 text-[12px] font-semibold text-danger">
                {job.pendingRequestCount} בקשות
              </span>
            )}
          </div>
          <p className="mt-1 text-[14px] text-ink-2">
            {rel && <strong className="font-semibold text-ink">{rel} · </strong>}
            {formatJobDate(job.date)}
          </p>
          <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-[13px] text-ink-2">
            <span className="inline-flex items-center gap-1">
              <ClockIcon size={15} />
              <span className="tabular">{job.reportTime}</span>
            </span>
            <span className="inline-flex min-w-0 items-center gap-1">
              <PinIcon size={15} />
              <span className="truncate">{job.location}</span>
            </span>
            <RegistrationPill state={job.registration} />
          </div>
        </div>
        <WorkerCountTag count={job.totalWorkers} />
      </Link>
    </li>
  );
}
